import Model from "./Model";
import ContentModel from './ContentModel';
import TextModel from './TextModel';

export default class AnnotationModel extends Model {
  id: number;
  correctionScoreId: number;
  coordinates: any;
  positive: boolean;

  static __typename: string = "Annotation";

  constructor(annotation: any, getters: any) {
    super(getters);
    this.id = annotation.id;
    this.coordinates = annotation.coordinates || {};
    this.correctionScoreId = annotation.correctionScoreId;
    this.positive = annotation.positive;
  }

  contents(): ContentModel[] {
    return this.getters
      .contentsByAnnotationId(this.id)
      .concat()
      .sort((A: ContentModel, B: ContentModel) => A.position - B.position);
  }

  contentString(): string {
    return this.contents()
      .filter((content:ContentModel) => content.textId)
      .map((content:ContentModel) => content.text())
      .reduce((acc: string, text:TextModel) => acc += text.body + '\n', '');
  }

  type(): string {
    if (this.positive) {
      return "Elogio";
    } else {
      return "Cuidado!";
    }
  }

  correctionScore() {
    return this.getters.correctionScoreById(this.correctionScoreId);
  }
}